Postlogin.Lesson = (function (my) {
    my.WrittenResponse = function (segmentData) {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const loadedResponse = segmentData.response;
        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container;
        let minimumWords = 0;
        let optimumWords = 0;
        let writtenWords = 0;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }

            if (Object.keys(me.options).length !== 1) {
                window.alert('Incorrect # of Options Records for this Written Response Activity');
            }

            $.each(me.options, (i, option) => {
                minimumWords = option.answer;
                optimumWords = option.hint;
            });

            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);
            const background = $('<img></img>')
                .attr('src', '/images/written-response-background.png')
                .addClass('written-response-background');
            const submitButton = $('<button type="button" class="submit-button" disabled><span>Keep Writing</span></button>');
            const progressNeedle = $('<img></img>').addClass('progress-needle').attr('src', '/images/word-o-meter-needle.png');

            const digit = $('<div></div>').addClass('digit');
            for (let i = 0; i < 10; i++) {
                const number = $(`<div>${i}</div>`).addClass('number');
                digit.append(number);
            }

            const wordCount = $('<div></div>').addClass('word-count cartoony').attr('data-value', '000');
            wordCount.append(digit);
            wordCount.append(digit.clone());
            wordCount.append(digit.clone());

            me.updateWordCount('');

            let textarea;
            if (me.activity_data.question_text) {
                textarea = $(`<textarea class="written-response-field" placeholder="${me.activity_data.question_text}"></textarea>`);
            } else {
                textarea = $('<textarea class="written-response-field" placeholder="Type your response here."></textarea>');
            }
            if (typeof loadedResponse !== 'undefined' && loadedResponse != null && loadedResponse !== '') {
                textarea.val(loadedResponse);
                me.updateWordCount(loadedResponse);
            }

            submitButton.on('click', () => {
                if (writtenWords >= minimumWords) {
                    const response = $(container).find('.written-response-field').val();
                    const data = {};
                    data.response = response;
                    data.user_lesson_segment_id = me.user_lesson_segment_id;

                    // if this is a real lesson and not a preview... save the students response
                    if (Postlogin.Lesson.getUserLessonId() != null && Postlogin.Lesson.getUserLessonId() > 0) {
                        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/') + me.segment_id}/save-response/`, data, () => {});
                    }

                    Postlogin.Lesson.Popup.showCompletionModal(me);
                    $(container)
                        .find('.submit-button')
                        .html('<span>Keep Writing</span>')
                        .prop('disabled', true)
                        .removeClass('animated tada');
                } else {
                    $(container)
                        .find('.submit-button')
                        .html('<span>Keep Writing</span>')
                        .prop('disabled', true)
                        .removeClass('animated tada');
                }
            });

            textarea.on('keyup', function () {
                me.updateWordCount($(this).val());
            });

            segmentContainer.append(background);
            segmentContainer.append(textarea);
            segmentContainer.append(submitButton);
            segmentContainer.append(progressNeedle);
            segmentContainer.append(wordCount);

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);

            me.resize();
            $(window).on('resize', _.debounce(me.resize, 250));
        };

        me.updateWordCount = function (content) {
            const $progressNeedle = container.find('.progress-needle');
            const $wordCount = container.find('.word-count');

            if ($.trim(content) === '') {
                writtenWords = 0;
            } else {
                writtenWords = content.replace(/\w+/g, 'x').replace(/[^x]+/g, '').length;
            }

            if (writtenWords > 0) {
                if (writtenWords > optimumWords) {
                    $progressNeedle.css('transform', 'rotate(180deg)');
                } else {
                    $progressNeedle.css('transform', `rotate(${(writtenWords / optimumWords) * 180}deg)`);
                }
            } else {
                $progressNeedle.css('transform', 'rotate(0deg)');
            }

            if (writtenWords >= minimumWords) {
                $(container).find('.submit-button').html('<span>Submit</span>').prop('disabled', false)
                    .addClass('animated tada');
            } else {
                $(container).find('.submit-button').html('<span>Keep Writing</span>').prop('disabled', true)
                    .removeClass('animated tada');
            }

            // update word counter
            let writtenWordsString = writtenWords.toString();
            writtenWordsString = String(`000${writtenWordsString}`).slice(-3);

            const numbers = writtenWordsString.toString().match(/\d{1}/g);

            $wordCount.find('.digit').each(function (i) {
                if (typeof numbers[i] !== 'undefined') {
                    $(this).find('.number:first-child').css('marginTop', `-${numbers[i]}00%`);
                }
            });
        };

        me.replay = function (forceShowHelp = false) {
            writtenWords = 0;
            $(container).find('.written-response-field').val('');

            const writtenContent = $(container).find('.written-response-field').val();
            me.updateWordCount(writtenContent);

            Postlogin.Lesson.hideNextButton();

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.speakQuestion(500, () => {
                        if (me.completed && !me.last) {
                            Postlogin.Lesson.showNextButton();
                        }
                    });
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();

            const writtenContent = $(container).find('.written-response-field').val();
            me.updateWordCount(writtenContent);

            Postlogin.Lesson.hideNextButton();

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.speakQuestion(500, () => {
                        if (me.completed && !me.last) {
                            Postlogin.Lesson.showNextButton();
                        }
                    });
                },
                false,
            );
        };

        me.hide = function () {
            me.breakdown();
        };

        me.resize = function () {};

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
